export function clearObject<T>(obj: T) {
  if (obj instanceof Object) {
    for (let field in obj) {
      if (obj[field] == undefined) delete obj[field];
    }
  }

  return obj;
}
